import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const ListMobilePanelApplication=()=>request({
    url: ApiURL.Query.GetListMobileApp,
    method: RequestType.GET,
   });
   const ListMobilePanelApplicationV2=(params:any)=>request({
    url: ApiURL.Query.GetListMobileAppV2+"?CountryId="+params,
    method: RequestType.GET,
   });

   const MobilePanelAppQuery = {
    ListMobilePanelApplication,
    ListMobilePanelApplicationV2
  };
  
  export default MobilePanelAppQuery;